"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("./styles"));
const components_1 = require("../../../components");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const scale_1 = require("../../../utils/scale");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const DeleteAccountTwoScreen = (props) => {
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                }, title: "アカウント削除", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u884C\u3046\u524D\u306B")),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(12),
                        } }, "Fujisan ID"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(8),
                        } }, "\u6295\u8CC7\u306E\u5148\u8F29\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u3082\u3001Fujisan\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u3088\u3063\u3066\u4FDD\u6709\u3055\u308C\u308B\u60C5\u5831\u306F\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } }, "Fujisan\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u65B9\u6CD5\u306F\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0\u3088\u308A\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(react_native_1.TouchableOpacity, null,
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(14),
                                lineHeight: (0, scale_1.moderateScale)(21),
                                color: "#007AFF",
                                marginTop: (0, scale_1.scale)(8),
                            }, onPress: () => {
                                (0, rootNavigation_1.navigate)(Routes_1.default.POLICY_DETAIL_SCREEN, {
                                    index: 2, itemIndex: 1
                                });
                            } })),
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(12),
                        } }, "\u518D\u5165\u4F1A\u306B\u3064\u3044\u3066"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            paddingTop: (0, scale_1.scale)(8),
                        } }, "\u4E00\u5EA6\u524A\u9664\u3055\u308C\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u5FA9\u6D3B\u3067\u304D\u307E\u305B\u3093\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } }, "\u518D\u5EA6\u53C2\u52A0\u3092\u5E0C\u671B\u3055\u308C\u308B\u5834\u5408\u306F\u3001\u65B0\u305F\u306B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"),
                    react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u6B21\u3078", onPress: () => {
                            props.navigation.navigate(Routes_1.default.DELETE_ACCOUNT_THREE_SCREEN);
                        } }))))));
};
exports.default = DeleteAccountTwoScreen;
